import { render, staticRenderFns } from "./ChannelUptimeChart.vue?vue&type=template&id=b4687f74&scoped=true&"
import script from "./ChannelUptimeChart.vue?vue&type=script&lang=js&"
export * from "./ChannelUptimeChart.vue?vue&type=script&lang=js&"
import style0 from "./ChannelUptimeChart.vue?vue&type=style&index=0&id=b4687f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4687f74",
  null
  
)

export default component.exports